import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, effect, input, output, viewChild } from '@angular/core';

/**
 * Sortie sonore d'une piste audio DISTANTE. Aucune surface visuelle.
 *
 * Pas d'attribut `autoplay` : la lecture est lancee par un `play()` explicite pour pouvoir
 * observer son refus. Le navigateur peut interdire de jouer du son avant un geste de
 * l'utilisateur ; on le signale (`bloque`) pour proposer « Activer le son », au lieu de
 * laisser un appel muet sans explication. Jamais `muted`.
 */
@Component({
  selector: 'app-sortie-audio',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<audio #lecteur class="hidden"></audio>`,
  styles: [`:host { display: none; }`],
})
export class SortieAudioComponent implements OnDestroy {
  readonly piste = input<MediaStreamTrack | null>(null);
  readonly bloque = output<void>();

  private readonly lecteur = viewChild.required<ElementRef<HTMLAudioElement>>('lecteur');

  constructor() {
    effect(() => {
      const audio = this.lecteur().nativeElement;
      const piste = this.piste();
      audio.srcObject = piste ? new MediaStream([piste]) : null;
      if (piste) void this.jouer();
    });
  }

  /** Relance la lecture — a appeler depuis un geste de l'utilisateur apres `bloque`. */
  async reprendre(): Promise<void> {
    await this.jouer();
  }

  private async jouer(): Promise<void> {
    try {
      await this.lecteur().nativeElement.play();
    } catch (e) {
      if ((e as { name?: string } | null)?.name === 'NotAllowedError') this.bloque.emit();
    }
  }

  ngOnDestroy(): void {
    this.lecteur().nativeElement.srcObject = null;
  }
}
